import { ZnglyAppContext } from '@/Utility/context/ZnglyAppContext';
import { Outlet, createRootRoute } from '@tanstack/react-router';

export const Route = createRootRoute({
  notFoundComponent: () => <></>,
  component: () => {
    return (
      <ZnglyAppContext>
        <Outlet />
      </ZnglyAppContext>
    );
  },
});
